module.exports = __webpack_public_path__ + "static/img/hainany_bg.6189de56.png";